import React, { useState } from 'react'
import { Link } from 'react-router-dom'

import { ReactComponent as ArrowDown } from '../../resources/img/firstSectionArrowDown.svg'
import '../../styles/faq/_titleCard.scss'
import { CSS } from '../../utils/domUtils'
import { PATHS } from '../../utils/paths'
import Header from '../common/Header'

const TitleCard: React.FC = () => {
	const [isMenuOpen, setIsMenuOpen] = useState(false)

	return (
		<div>
			<div className={`${CSS.TITLE_CARD}`}>
				<div className={CSS.CONTAINER}>
					<Header setIsMenuOpen={setIsMenuOpen} isMenuOpen={isMenuOpen} />
					<h1 className={`${CSS.TITLE_CARD_TITLE} ${CSS.CARD_TITLE}`}>FAQ</h1>
					<h2 className={CSS.FLEX_CENTER}>
						<div className={CSS.TITLE_CARD_SUBTITLE}>
							Find answers to some of our most frequently asked questions. <br /> For more information on
							how we protect data, take a look at our <Link to={PATHS.HOW_IT_WORKS}>How It Works</Link>{' '}
							page.
						</div>
					</h2>
					<div className={CSS.TITLE_ARROW}>
						<ArrowDown />
					</div>
				</div>
			</div>
		</div>
	)
}

export default TitleCard
